import { Loader2Icon, Upload } from 'lucide-react'
import React, { useState } from 'react'
import { toast } from 'sonner'
import { useTranslation } from 'react-i18next'

import { InfluencerData } from '../../../core/interface/chronique.interface'
import PostDataFromSelectedInfluencer from '../../../core/api/services/bookmetrie/private-reports/chroniqueur/post-data-from-selected-influencer.service'
import { Button } from '../../ui/button'
import DownloadCsvUtil from '../../../core/utils/downloadCsv.util'

interface AudienceValidatedSummaryProps {
  reportId: string
  chroniqueId: string
  selectedUsers: InfluencerData[]
}

const AudienceValidatedSummary: React.FC<AudienceValidatedSummaryProps> = ({
  reportId,
  chroniqueId,
  selectedUsers,
}) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  const formatAddress = (influencer: InfluencerData['influencer']) => {
    const parts = [
      influencer.address,
      influencer.zip_code,
      influencer.city,
    ].filter(Boolean)
    return parts.join(', ')
  }

  const handleImportAudience = () => {
    setLoading(true)
    PostDataFromSelectedInfluencer(
      selectedUsers.map((user) => user.influencer.userid),
      chroniqueId,
    )
      .then((response: any) => {
        if (response?.data) {
          DownloadCsvUtil(response.data, `chroniqueurs_${chroniqueId}.csv`)
        }
        window.location.reload()
      })
      .catch(() => {
        toast.error(
          "Une erreur est survenue lors de l'importation des chroniqueurs.",
        )
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <div className="h-full w-full bg-gray-50 p-6">
      <div className="bg-white rounded-lg shadow-sm">
        <div className="overflow-x-auto h-[70vh]">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-3 px-4 font-medium text-gray-700 text-sm">
                  Prénom
                </th>
                <th className="text-left py-3 px-4 font-medium text-gray-700 text-sm">
                  Nom
                </th>
                <th className="text-left py-3 px-4 font-medium text-gray-700 text-sm">
                  Email Gleeph
                </th>
                <th className="text-left py-3 px-4 font-medium text-gray-700 text-sm">
                  Pseudo Gleeph
                </th>
                <th className="text-left py-3 px-4 font-medium text-gray-700 text-sm">
                  Adresse postale
                </th>
                <th className="text-left py-3 px-4 font-medium text-gray-700 text-sm">
                  Pays
                </th>
                <th className="text-left py-3 px-4 font-medium text-gray-700 text-sm">
                  Numéro téléphone
                </th>
              </tr>
            </thead>
            <tbody>
              {selectedUsers.map((user, index) => (
                <tr
                  key={user.influencer.userid}
                  className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                >
                  <td className="py-3 px-4 text-sm text-gray-900">
                    {user.influencer.first_name}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-900">
                    {user.influencer.last_name}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-600">
                    {user.influencer.email}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-600">
                    {user.influencer.pseudonym}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-600">
                    {formatAddress(user.influencer)}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-600">
                    {user.influencer.country}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-600">
                    {user.influencer.phone_number || '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {selectedUsers.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            Aucun utilisateur sélectionné
          </div>
        )}
      </div>
      <div className="absolute bottom-8 mx-auto left-0 right-0 flex justify-center">
        <Button onClick={handleImportAudience} disabled={loading}>
          {loading ? (
            <>
              <Loader2Icon className="animate-spin" />{' '}
              {t('chroniqueurView.loading')}
            </>
          ) : (
            <>
              <Upload className="h-4 w-4" />
              {t('chroniqueurView.downloadInfluencer')}
            </>
          )}
        </Button>
      </div>
    </div>
  )
}

export default AudienceValidatedSummary
